module.exports = __webpack_public_path__ + "img/29_40.bd5ccb53.png";